import { FileText, Lock } from "lucide-react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, SectionLabel } from "@/components/Reveal";
import { DATA_ROOM, CONTACT } from "@/lib/content";

export default function DataRoom() {
    return (
        <section
            id="dataroom"
            className="relative mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32"
            data-testid="data-room"
        >
            <Reveal>
                <SectionLabel index="11">Data Room</SectionLabel>
            </Reveal>

            <div className="grid gap-14 md:grid-cols-12">
                <div className="md:col-span-4">
                    <Reveal delay={0.1}>
                        <h2 className="font-display text-3xl md:text-4xl font-light leading-tight text-white">
                            Due diligence,{" "}
                            <span className="italic text-gold">
                                organized and ready.
                            </span>
                        </h2>
                        <div className="mt-8 flex items-start gap-3 border border-white/10 bg-white/[0.02] p-5">
                            <Lock className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
                            <p className="text-sm leading-relaxed text-white/60">
                                Access to the full data room is provided to serious
                                investors after initial qualification.
                            </p>
                        </div>
                        <a
                            href="mailto:investors@h3ir.com?subject=Request%20Data%20Room%20Access"
                            data-testid="dataroom-request-access"
                            className="mt-6 inline-flex items-center gap-3 border border-gold/60 bg-gold/[0.04] px-6 py-3.5 font-mono text-xs uppercase tracking-[0.2em] text-gold transition-all duration-300 hover:bg-gold hover:text-navy-950"
                        >
                            Request Full Access
                        </a>
                    </Reveal>
                </div>

                <div className="md:col-span-8">
                    <Reveal delay={0.15}>
                        <Accordion
                            type="single"
                            collapsible
                            defaultValue="item-0"
                            className="border border-white/10"
                        >
                            {DATA_ROOM.map((group, idx) => (
                                <AccordionItem
                                    key={group.category}
                                    value={`item-${idx}`}
                                    className="border-b border-white/10 last:border-b-0 px-6"
                                >
                                    <AccordionTrigger
                                        data-testid={`dataroom-group-${idx}`}
                                        className="py-6 text-left font-display text-lg md:text-xl font-light text-white hover:text-gold hover:no-underline"
                                    >
                                        {group.category}
                                    </AccordionTrigger>
                                    <AccordionContent className="pb-6">
                                        <ul className="space-y-3">
                                            {group.items.map((item) => (
                                                <li
                                                    key={item}
                                                    className="flex items-start gap-3 text-sm leading-relaxed text-white/65"
                                                >
                                                    <FileText className="mt-0.5 h-4 w-4 shrink-0 text-gold/60" />
                                                    {item}
                                                </li>
                                            ))}
                                        </ul>
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
